<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid p-0">
        <div class="row justify-content-center align-items-center min-vh-100">
          <div class="col-10 col-md-6 col-lg-4">
            <div class="text-center">
              <div>
                <div class="logo d-block mb-4">
                  <img class="img-fluid" src="../../../assets/images/logo/sfa_logo.svg" alt="SFA Logo" style="max-width: 200px;">
                </div>
                <div class="login-main">
                  <form class="theme-form" @submit.prevent="handleRequestOTP">
                    <h4 class="mb-4">Forgot Password</h4>
                    <p class="mb-4">Enter your mobile number, we will send an One Time Password to your mobile number.</p>
                    <div class="form-group mb-3">
                      <label class="form-label visually-hidden" for="mobileNumber">Mobile Number</label>
                      <input
                        class="form-control"
                        id="mobileNumber"
                        type="tel"
                        placeholder="0771234567"
                        v-model="user.mobile.value"
                        @input="filterMobileInput"
                        maxlength="10"
                        required
                      >
                    </div>

                    <!-- Request OTP Button -->
                    <div class="d-grid mt-4">
                      <button class="btn button-default btn-block w-100" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span v-else>Continue</span>
                      </button>
                    </div>

                    <div class="mt-4">
                      <a href="/login" class="btn-link text-muted">Back to Login</a>
                    </div>
                    <br>

                    <!-- Copyright widget -->
                    <small class="mt-4 mb-0 text-center text-xs">
                      Copyright &copy; 2024. All Rights Reserved. <br> Developed by LAUGFS Group IT
                    </small>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestOTP } from '@/services/dataService';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      user: {
        mobile: {
          value: '',
          errormsg: ''
        },
        requestOTPError: '', // Add this line for request OTP Error message
      },
      token: '', // Store token here
      loading: false // Add loading state
    };
  },

  setup() {
    const router = useRouter();
    const toast = useToast(); // Initialize the toaster
    return { router, toast };
  },

  methods: {
    async handleRequestOTP() {
      this.user.requestOTPError = ''; // Clear previous request OTP Error message

      if (!this.user.mobile.value) {
        this.user.mobile.errormsg = 'Mobile number required';
        this.toast.error('Mobile number is required'); // Show toast for mobile number error
        return;
      } else if (!this.validMobile(this.user.mobile.value)) {
        this.user.mobile.errormsg = 'Valid 10-digit mobile number required.';
        this.toast.error('Please enter a valid 10-digit mobile number'); // Show toast for invalid mobile number
        return;
      } else {
        this.user.mobile.errormsg = '';
      }

      this.loading = true; // Set loading to true when login starts

      try {
        // Request OTP API call
        const userResponse = await requestOTP(this.user.mobile.value);

        // Show success toaster with response message
        if (userResponse.data && userResponse.data.message) {
          // Check if `mobile` has a value
          if (userResponse.data.data.mobile) {
            localStorage.setItem('token_set', userResponse.data.data.token);
            localStorage.setItem('mobile', userResponse.data.data.mobile);
          } else {
            localStorage.setItem('token_set', userResponse.data.data.token);
            localStorage.setItem('mobile', this.user.mobile.value);
          }
          this.toast.success(userResponse.data.message);
          this.$router.push('/verify-otp');
        }
      } catch (error) {
        // Handle invalid credentials
        if (error.response && error.response.data && error.response.data.message) {
          this.user.requestOTPError = error.response.data.message;
          this.toast.error(this.user.requestOTPError); // Show toaster for login error
        } else {
          this.user.requestOTPError = "An error occurred. Please try again.";
          this.toast.error(this.user.requestOTPError); // Show toaster for general error
        }
        console.error('API Error:', error);
      } finally {
        this.loading = false; // Set loading to false when login completes
      }
    },

    validMobile(mobile) {
      const re = /^\d{10}$/; // Regex for 10-digit mobile number
      return re.test(mobile);
    },

    filterMobileInput(event) {
      const value = event.target.value;
      this.user.mobile.value = value.replace(/\D/g, ''); // Remove non-numeric characters
    },
  }
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8f9fa;
}

.login-main {
  background-color: #fff;
  padding: 30px 40px; /* 30px top/bottom padding, 40px left/right padding */
  border-radius: 20px; /* Adjust the border radius as needed */
}

.text-muted {
  color: #6c757d;
}

a {
  text-decoration: none;
}

/* Forgot Password link hover effect */
.btn-link:hover {
  color: #253069 !important;
  text-decoration: none;
}
</style>